export const resolveError = error =>
  error.response.json().then(body => {
    error.body = body;
    return Promise.reject(error);
  });
